import { point, distance } from '@turf/turf';

//Draw Point
export const handleDrawPoint = (event, points, setPoints, geometryName, layers, setAttributeFormOpen) => {
  const safeLayers = Array.isArray(layers) ? layers : [];

  let coordinate;
  if (Array.isArray(event)) {
    // Direktno niz koordinata [x, y]
    coordinate = event;
  } else if (event && event.coordinate) {
    // Event objekat sa koordinatom
    coordinate = event.coordinate;
  } else {
    console.warn("Nepoznat format event parametra:", event);
    return;
  }

  const [longitude, latitude] = snapToVertex(coordinate, safeLayers, 10);

  const newPoint = {
    id: `point-${Date.now()}`,
    coordinates: [longitude, latitude],
    geometry_name: geometryName
  };

  setPoints([...points, newPoint]);
  setAttributeFormOpen(true);
};


//Draw MultiPoint
export const handleDrawMultiPoint = (event, multiPoints, setMultiPoints, geometryName, layers, setAttributeFormOpen) => {
  const [longitude, latitude] = snapToVertex(event.coordinate, layers, 10);
  const newCoordinate = [longitude, latitude];

  setMultiPoints(prevMultiPoints => {
    // Provera da li već postoji MultiPoint geometrija
    let updatedPoints;
    if (prevMultiPoints.length === 0) {
      // Ako ne postoji, kreiraj novu MultiPoint geometriju
      updatedPoints = [newCoordinate];
    } else {
      // Ako postoji, dodaj novu tačku u postojeće koordinate
      updatedPoints = [...prevMultiPoints[0].geometry.coordinates, newCoordinate];
    }

    return [{
      type: 'Feature',
      geometry: {
        type: 'MultiPoint',
        coordinates: updatedPoints
      },
      properties: {},
      geometry_name: geometryName
    }];
  });
  setAttributeFormOpen(true);
};

//Draw LineString
export const handleDrawLine = (event, currentDrawing, setCurrentDrawing, layers) => {
  const [longitude, latitude] = snapToVertex(event.coordinate, layers, 10);
  setCurrentDrawing([...currentDrawing, [longitude, latitude]]);
};

export const handleCompleteDrawingLine = (currentDrawing, lines, setLines, geometryName, setAttributeFormOpen) => {
  if (currentDrawing.length < 2) {
    // console.log('A LineString requires at least 2 points.');
    return;
  }

  const newLine = { id: `line-${Date.now()}`, coordinates: currentDrawing, geometry_name: geometryName };

  setLines([...lines, newLine]);
  setAttributeFormOpen(true);
};

//Draw MultiLineString
export const handleDrawMultiLine = (event, currentDrawing, setCurrentDrawing, layers) => {
  const [longitude, latitude] = snapToVertex(event.coordinate, layers, 10);
  setCurrentDrawing([...currentDrawing, [longitude, latitude]]);
};

export const handleCompleteDrawingMultiLine = (currentDrawing, multiLines, setMultiLines, geometryName, setAttributeFormOpen) => {
  if (currentDrawing.length < 2) {
    // console.log('Not enough points to complete drawing');
    return; // Ensure there are enough points to form a line
  }
  const newMultiLine = {
    id: `multiline-${Date.now()}`,
    coordinates: [currentDrawing],
    geometry_name: geometryName
  };

  setMultiLines([...multiLines, newMultiLine]);
  setAttributeFormOpen(true);
};

//DrawPolygon
export const handleDrawPolygon = (event, currentDrawing, setCurrentDrawing, layers) => {
  const [longitude, latitude] = snapToVertex(event.coordinate, layers, 10);
  setCurrentDrawing([...currentDrawing, [longitude, latitude]]);
};

export const handleCompleteDrawingPolygon = (currentDrawing, polygons, setPolygons, geometryName, setAttributeFormOpen) => {
  const closedRing = [...currentDrawing];
  if (currentDrawing[0][0] !== currentDrawing[currentDrawing.length - 1][0] || currentDrawing[0][1] !== currentDrawing[currentDrawing.length - 1][1]) {
    closedRing.push(currentDrawing[0]);
  }
  const newPolygon = { id: `polygon-${Date.now()}`, coordinates: [closedRing], geometry_name: geometryName };
  setPolygons([...polygons, newPolygon]); setAttributeFormOpen(true);
};

//DrawMultiPolygon
export const handleDrawMultiPolygon = (event, currentDrawing, setCurrentDrawing, layers) => {
  const [longitude, latitude] = snapToVertex(event.coordinate, layers, 10);
  setCurrentDrawing([...currentDrawing, [longitude, latitude]]);
};

export const handleCompleteDrawingMultiPolygon = (currentDrawing, multiPolygons, setMultiPolygons, geometryName, setAttributeFormOpen) => {
  const closedRing = [...currentDrawing];
  if (currentDrawing[0][0] !== currentDrawing[currentDrawing.length - 1][0] || currentDrawing[0][1] !== currentDrawing[currentDrawing.length - 1][1]) {
    closedRing.push(currentDrawing[0]);
  }
  const newMultiPolygon = { id: `multiPolygon-${Date.now()}`, coordinates: [[closedRing]], geometry_name: geometryName };
  setMultiPolygons([...multiPolygons, newMultiPolygon]);
  setAttributeFormOpen(true);
};

export const handleUndoDrawing = (currentDrawing, setCurrentDrawing) => {
  if (currentDrawing.length > 0) {
    setCurrentDrawing(currentDrawing.slice(0, -1));
  }
};

export const handleMeasureDrawing = (event, currentMeasureDrawing, setCurrentMeasureDrawing, layers) => {
  const [longitude, latitude] = snapToVertex(event.coordinate, layers, 10);
  setCurrentMeasureDrawing([...currentMeasureDrawing, [longitude, latitude]]);
};

export const handleMoveVertex = (coordinate, clickedFeature, draggingVertex, setClickedFeature) => {
  // Ažuriraj poziciju verteksa tokom prevlačenja
  const updatedFeature = { ...clickedFeature };

  if (updatedFeature.geometry.type === 'Polygon') {
    // Ažuriranje verteksa u Polygonu
    updatedFeature.geometry.coordinates[0][draggingVertex] = coordinate;
  } else if (updatedFeature.geometry.type === 'LineString') {
    // Ažuriranje verteksa u LineString-u
    updatedFeature.geometry.coordinates[draggingVertex] = coordinate;
  } else if (updatedFeature.geometry.type === 'MultiPolygon') {
    const { polygonIndex, closestIndex } = draggingVertex;
    const polygon = updatedFeature.geometry.coordinates[polygonIndex][0];

    // Proveri da li je najbliža tačka prva ili poslednja (zatvorena linija)
    if (closestIndex === 0 || closestIndex === polygon.length - 1) {
      // Ažuriraj prvu i poslednju tačku
      polygon[0] = coordinate;
      polygon[polygon.length - 1] = coordinate;
    } else {
      // Ažuriraj bilo koju drugu tačku
      polygon[closestIndex] = coordinate;
    }
  } else if (updatedFeature.geometry.type === 'MultiLineString') {
    // Ažuriranje verteksa u MultiLineString-u
    const { lineIndex, closestIndex } = draggingVertex;
    updatedFeature.geometry.coordinates[lineIndex][closestIndex] = coordinate;
  } else if (updatedFeature.geometry.type === 'Point') {
    // Ažuriranje koordinate za Point
    updatedFeature.geometry.coordinates = coordinate;
  }

  setClickedFeature(updatedFeature);
};

export const snapToVertex = (currentPoint, layers, minDistance) => {
  let nearestVertex = null;
  let minDist = minDistance;

  const safeLayers = Array.isArray(layers) ? layers : [];

  safeLayers.forEach(layer => {
    if (!layer?.props?.visible) return;

    const data = layer?.props?.data;
    if (!data) return;

    if (Array.isArray(data)) {
      data.forEach(item => {
        const coords = item?.geometry?.coordinates || item?.position;

        if (!Array.isArray(coords) || coords.length < 2) return;

        const dist = distance(point(currentPoint), point(coords), { units: "meters" });

        if (dist < minDist) {
          minDist = dist;
          nearestVertex = coords;
        }
      });

      return;
    }

    const features = Array.isArray(data?.features) ? data.features : [];

    features.forEach(feature => {
      const geometry = feature?.geometry;
      const coords = geometry?.coordinates;
      const type = geometry?.type;

      if (!geometry || !coords || !type) return;

      if (type === "Point") {
        const dist = distance(point(currentPoint), point(coords), { units: "meters" });

        if (dist < minDist) {
          minDist = dist;
          nearestVertex = coords;
        }

        return;
      }

      if (type === "LineString" || type === "MultiPoint") {
        coords.forEach(vertex => {
          if (!Array.isArray(vertex) || vertex.length < 2) return;

          const dist = distance(point(currentPoint), point(vertex), { units: "meters" });

          if (dist < minDist) {
            minDist = dist;
            nearestVertex = vertex;
          }
        });

        return;
      }

      if (type === "Polygon" || type === "MultiLineString") {
        coords.forEach(ring => {
          if (!Array.isArray(ring)) return;

          ring.forEach(vertex => {
            if (!Array.isArray(vertex) || vertex.length < 2) return;

            const dist = distance(point(currentPoint), point(vertex), { units: "meters" });

            if (dist < minDist) {
              minDist = dist;
              nearestVertex = vertex;
            }
          });
        });

        return;
      }

      if (type === "MultiPolygon") {
        coords.forEach(polygon => {
          if (!Array.isArray(polygon)) return;

          polygon.forEach(ring => {
            if (!Array.isArray(ring)) return;

            ring.forEach(vertex => {
              if (!Array.isArray(vertex) || vertex.length < 2) return;

              const dist = distance(point(currentPoint), point(vertex), { units: "meters" });

              if (dist < minDist) {
                minDist = dist;
                nearestVertex = vertex;
              }
            });
          });
        });
      }
    });
  });

  return nearestVertex || currentPoint;
};

export const snapToSecondClosestVertex = (currentPoint, layers, minDistance, firstNearestVertex) => {
  let vertices = [];

  layers.forEach(layer => {
    const data = layer.props.data;

    if (layer.props.visible) {
      data.features.forEach(feature => {
        const coords = feature.geometry.coordinates;

        if (feature.geometry.type === 'Point') {
          const dist = distance(currentPoint, point(coords), { units: 'meters' });
          if (dist < minDistance) {
            vertices.push({ vertex: coords, dist });
          }
        } else if (feature.geometry.type === 'LineString' || feature.geometry.type === 'MultiPoint') {
          coords.forEach(vertex => {
            if (vertex.length >= 2) {
              const dist = distance(currentPoint, point(vertex), { units: 'meters' });
              if (dist < minDistance) {
                vertices.push({ vertex, dist });
              }
            }
          });
        } else if (feature.geometry.type === 'Polygon' || feature.geometry.type === 'MultiLineString') {
          coords.forEach(ring => {
            ring.forEach(vertex => {
              if (vertex.length >= 2) {
                const dist = distance(currentPoint, point(vertex), { units: 'meters' });
                if (dist < minDistance) {
                  vertices.push({ vertex, dist });
                }
              }
            });
          });
        } else if (feature.geometry.type === 'MultiPolygon') {
          coords.forEach(polygon => {
            polygon.forEach(ring => {
              ring.forEach(vertex => {
                if (vertex.length >= 2) {
                  const dist = distance(currentPoint, point(vertex), { units: 'meters' });
                  if (dist < minDistance) {
                    vertices.push({ vertex, dist });
                  }
                }
              });
            });
          });
        }
      });
    }
  });

  // Sortiraj vertekse prema udaljenosti
  vertices.sort((a, b) => a.dist - b.dist);

  // Pronađi drugi najbliži verteks koji nije jednak prvom najbližem verteksu
  let secondClosestVertex = null;
  for (let i = 0; i < vertices.length; i++) {
    if (vertices[i].vertex !== firstNearestVertex) {
      secondClosestVertex = vertices[i].vertex;
      break;
    }
  }

  // Ako je drugi najbliži verteks isti kao prvi, pokušaj sa trećim
  if (secondClosestVertex === firstNearestVertex && vertices.length > 2) {
    for (let i = 1; i < vertices.length; i++) {
      if (vertices[i].vertex !== firstNearestVertex) {
        return vertices[i].vertex;
      }
    }
  }

  // Vrati drugi najbliži verteks ili `null` ako ne postoji
  return secondClosestVertex;
};


export const findClosestVertex = (coordinate, clickedFeature) => {
  const { geometry } = clickedFeature;

  // Ako je geometrija `Point`
  if (geometry.type === 'Point') {
    // console.log('Feature is a Point.');
    return 0; // Tačka ima samo jedan set koordinata
  }

  // Ako je geometrija `LineString`
  if (geometry.type === 'LineString') {
    return findClosestInCoordinates(geometry.coordinates, coordinate);
  }

  // Ako je geometrija `Polygon`
  if (geometry.type === 'Polygon') {
    return findClosestInCoordinates(geometry.coordinates[0], coordinate); // Uzimamo prvi (spoljašnji) prsten
  }

  // Ako je geometrija `MultiPolygon`
  if (geometry.type === 'MultiPolygon') {
    let closestIndex = null;
    let closestDistance = Infinity;
    let polygonIndex = null;

    geometry.coordinates.forEach((polygon, polyIndex) => {
      const outerRing = polygon[0]; // Uzimamo spoljašnji prsten
      const closestInPolygon = findClosestInCoordinates(outerRing, coordinate);

      const distance = calculateDistance(coordinate, outerRing[closestInPolygon]);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = closestInPolygon;
        polygonIndex = polyIndex;
      }
    });

    return { polygonIndex, closestIndex };
  }

  // Ako je geometrija `MultiLineString`
  if (geometry.type === 'MultiLineString') {
    let closestIndex = null;
    let closestDistance = Infinity;
    let lineIndex = null;

    geometry.coordinates.forEach((line, lineIdx) => {
      const closestInLine = findClosestInCoordinates(line, coordinate);

      const distance = calculateDistance(coordinate, line[closestInLine]);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = closestInLine;
        lineIndex = lineIdx;
      }
    });

    return { lineIndex, closestIndex };
  }

  console.error('Unsupported geometry type:', geometry.type);
  return null;
};

const findClosestInCoordinates = (coordinates, coordinate) => {
  let closestIndex = null;
  let closestDistance = Infinity;

  coordinates.forEach((coord, index) => {
    const distance = calculateDistance(coordinate, coord);
    if (distance < closestDistance) {
      closestDistance = distance;
      closestIndex = index;
    }
  });

  return closestIndex;
};

const calculateDistance = (lngLat, coordinate) => {
  const dx = lngLat[0] - coordinate[0];
  const dy = lngLat[1] - coordinate[1];
  return Math.sqrt(dx * dx + dy * dy);
};